<template>
  <main class="wrapper-content-with-toolbar">
    <h1>{{ $t('customer') }}</h1>
    <template v-if="!isLoading">
      <b-row>

      <b-card class="border">
        <b-row>
          <LmTextInput
            class="col-12 col-md-6"
            :label="$t('customer_name')"
            :placeholder="$t('enter_customer_name')"
            v-model="$v.form.name.$model"
            :v="v('form.name')"
          />
          <LmTextArea
            class="col-12 col-md-6"
            :label="$t('description')"
            :placeholder="$t('enter_description')"
            v-model="form.description"
            :v="v('form.description')"
          />
          <LmTextInput
            class="col-12 col-md-6"
            :label="$t('first_user_email')"
            v-model="$v.form.email.$model"
            :v="v('form.email')"
          />
          <LmTreeSelect
            class="col-12 col-md-4"
            :label="$t('plan')"
            pathToGetOptions="/customer/plans"
            v-model="$v.form.plan.$model"
            :v="v('form.plan')"
          />
          <LmCheckbox
            class="mt-4 col-12 col-md-2 text-right"
            variant="switch"
            v-model="form.trial"
            labelSingle="Prueba gratuita"
          />
          <LmTextInput
            class="col-12 col-md-6"
            :label="$t('firstname')"
            v-model="$v.form.firstname.$model"
            :v="v('form.firstname')"
          />
          <LmTextInput
            class="col-12 col-md-6"
            :label="$t('lastname')"
            v-model="$v.form.lastname.$model"
            :v="v('form.lastname')"
          />
          <LmTextInput
            v-if="!isOnEditMode"
            class="col-12"
            :label="$t('password')"
            v-model="$v.form.password.$model"
            :v="v('form.password')"
          />
        </b-row>
      </b-card>

      <!-- Toolbar -->
      <LmToolbar
        ref="toolbar"
        :isOnEditMode="isOnEditMode"
        :items="toolbarItems"
        :config="toolbarConfig"
      />
      </b-row>

    </template>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
    <div class="buttons">
      <LmButton
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click="onCancel"
          :isProcessing="isProcessing"
        />
        <LmButton
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && !form.deleted"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_logical_delete_customer')"
          buttonClass="btn-danger"
          :value="$t('logical_delete')"
          @click="onDelete"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && form.deleted"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_recover_customer')"
          buttonClass="btn-danger"
          :value="$t('recover')"
          @click="onRecover"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && !form.active"
          :value="$t('activate')"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_reactivate_customer')"
          buttonClass="btn-success"
          @click="onReactivate()"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && form.active"
          :value="$t('deactivate')"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_reactivate')"
          buttonClass="btn-success"
          @click="onDeactivate()"
          :isProcessing="isProcessing"
        />
    </div>
  </main>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmRadio from '@/components/form/elements/LmRadio'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmToolbar from '@/components/lmToolBar'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmTextInput,
    LmCheckbox,
    LmTextArea,
    LmButton,
    LmRadio,
    LmToolbar
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    frontendRouteToRedirectAfterCreated: {
      type: String,
      required: true
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      form: {
        name: '',
        active: true,
        description: '',
        email: '',
        firstname: '',
        lastname: '',
        plan: null,
        password: '',
        trial: false
      },
      isProcessing: false
    }
  },
  validations () {
    const validations = {
      form: {
        name: { required },
        email: { required },
        firstname: { required },
        lastname: { required },
        plan: { required }
      }
    }
    if (!this.isOnEditMode) {
      validations.form.password = { required }
    }
    return validations
  },
  computed: {
    toolbarItems () {
      let items = []
      if (this.isOnEditMode) {
        items = [
          'auditMovements'
        ]
      }
      return items
    },
    toolbarConfig () {
      return {
        auditMovements: {
          serviceName: 'customer'
        },
        logMovements: {}
      }
    }
  },
  methods: {
    v (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSubmit () {
      try {
        await this.validateForm(this.$v)
        this.isProcessing = true
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/edit/${this.$route.params.id}`, this.form)
        } else {
          await commonsApi.axiosPostWrapper(`/${this.serviceEndpoint}/new`, this.form)
        }
        this.lmToastSuccessMessage(
          `${this.$t('saved_successfully')} '${this.form.name}'`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosDeleteWrapper(`/${this.serviceEndpoint}/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `${this.$t('was_successfully_deleted')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onRecover () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/recover/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `${this.$t('was_successfully_recovered')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onReactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/reactivate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('was_successfully_reactivated')}`, `${this.$t('it_was_successfully_reactivated')}`)
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onDeactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/deactivate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('was_successfully_deactivated')}`, `${this.$t('it_was_successfully_deactivated')}`)
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`)
      this.form = res.data
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
